import {useQuery} from "react-query";
import {useMainContext} from "../../../../contexts/main";
import {makeQueryFilters} from "../../../../utils/query-maker";
import {filterFetch, normalFetch} from "../../../fetch-api/get";


export const CONTRACT_KEYS = {
    LIST_PAYMENTS: 'list-payments',
    GET_PAYMENT: 'get-payment'
}


const useListPayments = (filters, pagination, extra, csv) => {

    const { lang } = useMainContext()
    const params = {...makeQueryFilters(filters, lang), ...pagination}
    if (csv){
        params.export = 'csv'
    }

    return useQuery(
        CONTRACT_KEYS.LIST_PAYMENTS, () => filterFetch(params, 'payments/admin')
    )
}

const useGetPayment = (id, onSuccess) => {

    return useQuery(
        [CONTRACT_KEYS.GET_PAYMENT, id], () => normalFetch(`payments/admin/${id}`),
        {
            select: res => res?.data?.data,
            enabled: false,
            onSuccess: (res) => {
                onSuccess(res)
            }
        }
    )
}

export {
    useListPayments,
    useGetPayment
}
